import { Component, input, ChangeDetectionStrategy } from '@angular/core';
import { TopAttackedUsersResponse } from 'src/app/core/models/analytics/es-models';
import { BaseComponent } from 'src/app/core/shared/common/base.component';


@Component({
  selector: 'app-es-top-attacked-users',
  standalone: true,
  imports: [],
  templateUrl: './es-top-attacked-users.component.html',
  styleUrl: './es-top-attacked-users.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EsTopAttackedUsersComponent extends BaseComponent {
  topAttackedUsers = input<TopAttackedUsersResponse>();
}
